import * as React from "react";
const IconFilter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      d="M3 8.475h12m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0m-6 8h12m-12 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconFilter;
